'use strict';

var callDateSet = require('../../common/internal/callDateSet');

function setDate(d, val) {
  callDateSet(d, 'Date', val);
}

module.exports = setDate;


// WEBPACK FOOTER //
// ./~/sugar-date/date/internal/setDate.js